import { useMutation } from '@tanstack/react-query';

import { namespaceAccessUpdate } from '@api/sdk.gen';

import { EnvironmentId } from '@/react/portainer/environments/types';
import { queryClient, withInvalidate } from '@/react-tools/react-query';
import { userQueryKeys } from '@/portainer/users/queries/queryKeys';
import { teamQueryKeys } from '@/react/portainer/users/teams/queries/query-keys';

import { namespaceAccessPolicyQueryKey } from './useNamespaceAccessPolicy';

export type UpdateNamespaceAccessesPayload = {
  UsersToAdd: number[];
  TeamsToAdd: number[];
  UsersToRemove: number[];
  TeamsToRemove: number[];
};

export function useUpdateNamespaceAccessesMutation(
  environmentId: EnvironmentId,
  namespaceName: string
) {
  return useMutation({
    mutationFn: (payload: UpdateNamespaceAccessesPayload) =>
      updateNamespaceAccesses(environmentId, namespaceName, payload),
    ...withInvalidate(queryClient, [
      namespaceAccessPolicyQueryKey(environmentId, namespaceName),
      userQueryKeys.base(),
      teamQueryKeys.base(),
    ]),
  });
}

async function updateNamespaceAccesses(
  environmentId: EnvironmentId,
  namespaceName: string,
  payload: UpdateNamespaceAccessesPayload
) {
  await namespaceAccessUpdate({
    path: { id: environmentId, rpn: namespaceName },
    body: payload,
  });
}
